import { DECREASEFROMCART, INCREASEFROMCART } from '../cart/actionTypes';
import { DECREASEPRODUCT, INCREASEPRODUCT } from '../products/actionTypes';

/* 
this middleware is to sync the quantity between the product and cart.
it checks the counter (plus, minus) operation in cart page
*/

const verifyQuantity = (store) => (next) => (action) => {
  const state = store.getState();

  /* 
  if the current cart quantity is one, 
  pressing the decrease (-) button will not increase the product quantity.
  */
  if (action.type === INCREASEPRODUCT) {
    const product = state.products.find(
      (product) => product.id === action.payload
    );

    const { quantity, originalQty } = product;

    if (quantity + 1 === originalQty) {
      return;
    }
  }

  /* 
  if the current cart quantity is equal to the original product quantity, 
  pressing the increase (+) button will not decrease the product quantity.
  */

  if (action.type === DECREASEPRODUCT) {
    const product = state.products.find(
      (product) => product.id === action.payload
    );

    const { quantity } = product;

    if (quantity === 0) {
      return;
    }
  }

  /* 
  if the current cart quantity is equal to the original product quantity, 
  pressing the increase (+) button will not increase the cart quantity
  */
  if (action.type === INCREASEFROMCART) {
    const cartItem = state.cart.find(
      (cartItem) => cartItem.id === action.payload
    );

    const { quantity, originalQty } = cartItem;

    if (quantity === originalQty) {
      return;
    }
  }

  /* 
  if the current cart quantity is one, 
  pressing the decrease (-) button will not decrease the cart quantity
  */
  if (action.type === DECREASEFROMCART) {
    const cartItem = state.cart.find(
      (cartItem) => cartItem.id === action.payload
    );

    const { quantity } = cartItem;

    if (quantity === 1) {
      return;
    }
  }

  return next(action);
};

export default verifyQuantity;
